export class WorkOrderDocument {
  // DynamoDB Keys
  PK?: string = null;
  SK?: string = null;
  GSI1PK?: string = null;
  GSI1SK?: string = null;
  workOrderId?: string = null;

  // Customer Information
  customerName?: string = null;
  vehicleYear?: string = null;
  vehicleMake?: string = null;
  vehicleModel?: string = null;
  vehicleVin?: string = null;
  vehicleOdometer?: number = null;

  // Work Summary and Pricing
  workSummary?: string = null;
  shopSupplies?: number = null;
  taxes?: number = null;
  additionalFees?: number = null;
  totalAmount?: number = null;

  // Additional Services Required (ASR)
  asrItems?: Array<{
    isAccepted?: boolean;
    isDeclined?: boolean;
    price?: number;
    description?: string;
    [key: string]: any;
  }> = [];

  // MPVI Results
  mpviResult?: any = null;
  mpviS3Url?: string = null;

  // Future Services
  futureServices?: Array<{
    isDeclined?: boolean;
    mileageInterval?: number;
    timeInterval?: number;
    [key: string]: any;
  }> = [];

  // OnStar & Digital Service
  onstarContact?: string = null;
  siriusxmContact?: string = null;

  // Additional Service Information
  invoice?: any = null;
  maintenanceMenu?: any = null;
  additionalService?: any[] = [];

  // Metadata and Timestamps
  metadata?: Record<string, any> = null;
  createdTimestamp?: string = null;
  updatedTimestamp?: string = null;

  constructor(obj?: WorkOrderDocument) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
